module.exports = __webpack_public_path__ + "img/accordion-opened.def3b458.png";